document.addEventListener("DOMContentLoaded", function () {
  if (window.screen.width < 800) {
    // ----- MENU -----
    var menu = document.querySelector(".main_nav .show_menu");
    var closeMenu = document.querySelector(".main_nav .close_menu");
    var menuForm = document.querySelector(".modal_parent");
    menu.addEventListener("click", openMenu);
    closeMenu.addEventListener("click", closemenu);
    function openMenu() {
      menuForm.classList.add("is_active");
      menu.classList.add("hidden_button");
      closeMenu.classList.add("visible_button");
    }
    function closemenu() {
      menuForm.classList.remove("is_active");
      menu.classList.remove("hidden_button");
      closeMenu.classList.remove("visible_button");
    }
    menuForm.addEventListener("click", function (event) {
      if (!event.target.closest(".inner")) {
        closemenu();
      }
    });
    // ----- END OF MENU -----
    var arrowIcon = document.querySelectorAll(".submenu_mobile_icn");
    arrowIcon.forEach(function (i) {
      i.addEventListener("click", toggleSubmenu);
      function toggleSubmenu(e) {
        e.stopPropagation();
        e.preventDefault();
        var submenu = this.parentNode.children[2];
        if (submenu.classList.contains("submenu_show")) {
          submenu.classList.remove("submenu_show");
          this.classList.remove("active_svg");
        } else {
          submenu.classList.add("submenu_show");
          this.classList.add("active_svg");
        }
      }
    });
  }
  //----- SEARCH -----
  var searchIcon = document.querySelector(".main_header .search .search_icon");
  var closeSearch = document.querySelector(
    ".main_header .search .close_search",
  );
  var searchForm = document.querySelector(
    ".main_header .search .search_parent",
  );
  var searchInput = document.querySelector(
    ".main_header .search .search_input",
  );
  if (searchIcon && searchForm) {
    searchIcon.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      searchForm.classList.add("visible");
      searchIcon.classList.add("hidden_button");
      closeSearch.classList.add("visible_button");
      searchInput.focus();
    });
    closeSearch.addEventListener("click", function (e) {
      e.preventDefault();
      closeSearchFunc();
    });
    searchForm.addEventListener("click", function (e) {
      if (!searchIcon.contains(e.target) && !searchInput.contains(e.target)) {
        closeSearchFunc();
      }
    });
  }
  function closeSearchFunc() {
    searchForm.classList.remove("visible");
    searchIcon.classList.remove("hidden_button");
    closeSearch.classList.remove("visible_button");
  }
  // ----- ADDED POSITION FIXED TO MODAL_PARENT & SEARCH_PARENT ----- //
  function handleScrollModalTop() {
    const header = document.querySelector(".main_header");
    const modal = document.querySelector(".modal_parent");
    const modalSearchList = document.querySelectorAll(".search_parent");

    if (!header || !modal) return;

    const headerHeight = header.offsetHeight;

    if (window.scrollY >= headerHeight) {
      modal.classList.add("scrolled");

      modalSearchList.forEach(function (search) {
        if (search.classList.contains("visible")) {
          search.classList.add("scrolled");
        }
      });
    } else {
      modal.classList.remove("scrolled");

      modalSearchList.forEach(function (search) {
        search.classList.remove("scrolled");
      });
    }
  }

  handleScrollModalTop();
  window.addEventListener("scroll", handleScrollModalTop);
  window.addEventListener("resize", handleScrollModalTop);
  // ----- END OF MODAL_PARENT & SEARCH_PARENT ----- //
  var direction = document.documentElement.getAttribute("dir") || "ltr";
  // ---- FRONT_A ----
  if (
    document.getElementById("front_a") &&
    document.getElementById("thumbnail-carousel")
  ) {
    var main = new Splide("#front_a", {
      type: "loop",
      arrows: true,
      rewind: true,
      interval: 4000,
      autoplay: true,
      height: "500px",
      pagination: false,
      direction: "ttb",
      breakpoints: {
        799: {
          gap: "16px",
          perPage: 2,
          perMove: 1,
          height: "unset",
          direction: direction,
        },
        600: {
          perPage: 1,
          perMove: 1,
          height: "unset",
          direction: direction,
        },
      },
    });
    var thumbnails = new Splide("#thumbnail-carousel", {
      perPage: 3,
      rewind: true,
      arrows: false,
      focus: "center",
      height: "500px",
      pagination: false,
      isNavigation: true,
      direction: "ttb",
      breakpoints: {
        799: {
          height: "150px",
        },
      },
    });
    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  }
  // ---- END OF FRONT_A ----
  // ---- MULTIMEDIA_A ----
  if (document.getElementById("multimedia_a")) {
    var main = new Splide("#multimedia_a", {
      type: "loop",
      arrows: false,
      rewind: true,
      interval: 4000,
      autoplay: true,
      height: "600px",
      direction: "ttb",
      breakpoints: {
        799: {
          perPage: 1,
          perMove: 1,
          height: "unset",
          direction: direction,
        },
      },
    });
    main.mount();
  }
  // ---- MULTIMEDIA_A ----
  // ----- TAB -----
  function setupTabs(tabHeaderSelector, tabContentSelector) {
    const tabHeaders = document.querySelectorAll(`${tabHeaderSelector} li`);
    const tabContents = document.querySelectorAll(
      `${tabContentSelector} > div`,
    );
    tabHeaders.forEach(function (item) {
      item.addEventListener("click", function () {
        if (!item.classList.contains("active")) {
          const tabIndex = Array.prototype.indexOf.call(tabHeaders, item);
          const nthChild = tabIndex + 1;
          // Remove active class from all headers
          tabHeaders.forEach((header) => header.classList.remove("active"));
          // Add active class to the clicked header
          item.classList.add("active");
          // Remove active class from all contents
          tabContents.forEach((content) => content.classList.remove("active"));
          // Add active class to the corresponding content
          document
            .querySelector(`${tabContentSelector} > div:nth-child(${nthChild})`)
            .classList.add("active");
        }
      });
    });
  }
  setupTabs("#tab_header", "#content");
  // ---- END OF TAB ----
  if (document.querySelectorAll(".archive_news_type")) {
    document.querySelectorAll(".archive_news_type").forEach((item) => {
      const flip = item.querySelector(".flip");
      const panel = item.querySelector(".panel");
      flip.addEventListener("click", () => {
        flip.classList.toggle("rotate");
        panel.classList.toggle("visible_panel");
      });
    });
  }
  // ---- END OF ARCHIVE ---- //
  // ---- EJS ---- //
  window.onload = function () {
    // Add event listener to "Show More" buttons
    document.querySelectorAll(".more").forEach(function (elem) {
      elem.addEventListener("click", function () {
        if (!elem.parentElement) {
          console.error("Button has been removed.");
          return;
        }
        showLoadingState(elem); // Show loading state
        moreLandNews(this);
      });
    });
  };

  function flattenObj(data) {
    var result = {};
    function recurse(cur, prop) {
      if (Object(cur) !== cur) {
        result[prop] = cur;
      } else if (Array.isArray(cur)) {
        for (var i = 0, l = cur.length; i < l; i++) {
          recurse(cur[i], prop + "[" + i + "]");
        }
        if (l == 0) result[prop] = [];
      } else {
        var isEmpty = true;
        for (var p in cur) {
          isEmpty = false;
          recurse(cur[p], prop ? prop + "[" + p + "]" : p);
        }
        if (isEmpty && prop) result[prop] = {};
      }
    }

    recurse(data, "");
    return result;
  }

  function moreLandNews(elem) {
    var params = elem.dataset.params;

    // Convert JSON parameters to JavaScript object
    var paramsToObj = JSON.parse(params);
    paramsToObj["getNavigation"] = true;

    var url = masterConfig.baseUrl + "newsstudios/ajaxList/?";
    var output = flattenObj(paramsToObj);

    // Create query string
    var searchParam = Object.entries(output)
      .map(function (item) {
        return item[0].replace(/\[[0-9]+\]/, "[]") + "=" + item[1];
      })
      .join("&");

    fetch(url + encodeURI(searchParam))
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        elem.innerText = showMoreText;

        // Handle pagination
        if (
          (data.hasOwnProperty("navigation") &&
            !data.navigation.hasOwnProperty("next")) ||
          !data.hasOwnProperty("navigation")
        ) {
          elem.remove();
        }

        if (
          data.hasOwnProperty("navigation") &&
          data.navigation.hasOwnProperty("next")
        ) {
          paramsToObj["offset"] = data.navigation.next.offset;
          paramsToObj["curp"] = data.navigation.next.curp;
          paramsToObj["dir"] = data.navigation.next.dir;

          elem.dataset.params = JSON.stringify(paramsToObj);
        }

        if (data.hasOwnProperty("navigation")) {
          delete data["navigation"];
        }

        /*
         * Find news list
         *
         * Supports:
         * 1. front_bb.ctp (tab mode)
         *    .media_content .active ul.news_list
         *
         * 2. front_b.ctp (normal mode)
         *    .front_bb ul.news_list
         */

        var newsListElement = null;

        // TAB MODE
        var mediaContentSection = document.querySelector(".media_content");

        if (mediaContentSection) {
          var activeSection = mediaContentSection.querySelector(".active");

          if (activeSection) {
            newsListElement = activeSection.querySelector("ul.news_list");
          }
        }

        // NORMAL MODE
        if (!newsListElement) {
          var parentBlock = elem.closest(".front_bb");

          if (parentBlock) {
            newsListElement = parentBlock.querySelector("ul.news_list");
          }
        }

        // Fallback
        if (!newsListElement) {
          console.error("News list not found.");
          return;
        }

        // Load template
        var templateElement = elem
          .closest(".front_bb")
          ?.querySelector(".more_template");

        if (!templateElement) {
          templateElement = document.querySelector(".more_template");
        }

        if (!templateElement) {
          console.error("More template not found.");
          return;
        }

        var html = ejs.render(templateElement.innerHTML, {
          rows: data,
          i18n: window.i18n,
          masterConfig: window.masterConfig,
        });

        html = html.replace(/<script type="text\/plain">/g, "");
        html = html.replace(/<\/script>/g, "");

        // Append new items
        newsListElement.insertAdjacentHTML("beforeend", html);

        // Reset button state
        resetButtonText(elem);
      })
      .catch(function (error) {
        console.error("Error fetching data:", error);
        resetButtonText(elem);
      });
  }
  // Function to change the button text to "Loading..." when clicked
  function showLoadingState(button) {
    button.innerHTML =
      Loading +
      ' <img src="/images/loading.svg" width="24" height="24" alt="loading">';
  }

  // Function to reset the button text to the default text
  function resetButtonText(button) {
    button.innerHTML =
      showMoreText +
      ' <img src="/images/spinner.svg" width="24" height="24" alt="loading">';
  }
});
